import { render, staticRenderFns } from "./BalanceSellerModal.vue?vue&type=template&id=8c4e53ca&scoped=true&"
import script from "./BalanceSellerModal.vue?vue&type=script&lang=js&"
export * from "./BalanceSellerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4e53ca",
  null
  
)

export default component.exports